<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-form ref="form" class="row" @submit.prevent="onInternalSubmit">
      <b-container class="bv-example-row">
        <!-- Section Headers -->
        <b-row>
          <b-col md="3">
            <div :style="textInfo">
              <p class="text-dark font-size-h5 font-weight-bold">
                Thông tin cơ bản
              </p>
            </div>
          </b-col>
          <b-col md="3">
            <div :style="textInfo">
              <p class="text-dark font-size-h5 font-weight-bold">
                {{
                  isIndividualProvider
                    ? 'Dành cho cá nhân'
                    : 'Dành cho doanh nghiệp'
                }}
              </p>
            </div>
          </b-col>
          <b-col md="3">
            <div :style="textInfo">
              <p class="text-dark font-size-h5 font-weight-bold">
                Điều khoản tài chính
              </p>
            </div>
          </b-col>
          <b-col md="3">
            <div :style="textInfo">
              <p class="text-dark font-size-h5 font-weight-bold">
                Liên kết thông tin khách hàng
              </p>
            </div>
          </b-col>
        </b-row>
        <!-- Row 1: Basic Info -->
        <b-row>
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-name">Tên nhà cung cấp:</label>
              <b-form-input
                tabindex="1"
                v-model.trim="$v.formData.name.$model"
                :state="validateState('name')"
                placeholder="Nhập tên nhà cung cấp"
                aria-describedby="input-name-live-feedback"
                size="sm"
              />
              <b-form-invalid-feedback v-if="!$v.formData.name.required"
                >Vui lòng nhập tên nhà cung cấp!</b-form-invalid-feedback
              >
              <b-form-invalid-feedback v-if="!$v.formData.name.minLength"
                >Nhập tên với ít nhất 3 kí tự!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="input-code"
                >Mã
                {{ isIndividualProvider ? 'cá nhân' : 'doanh nghiệp' }}:</label
              >
              <b-form-input
                tabindex="2"
                v-model.trim="formData.code"
                placeholder=""
                aria-describedby="input-code-help"
                size="sm"
              />
              <small
                id="input-code-help"
                class="form-text text-muted"
                v-if="!formData.code"
              >
                <i class="fa fa-exclamation-circle text-warning mr-1 fa-sm"></i>
                Để trống nếu bạn muốn hệ thống tự động sử dụng SĐT làm mã.
              </small>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="input-credit-limit">Hạn mức công nợ:</label>
              <b-form-input
                tabindex="4"
                v-model="$v.formData.creditLimit.$model"
                :state="validateState('creditLimit')"
                type="number"
                step="0.01"
                placeholder="Nhập hạn mức công nợ"
                aria-describedby="input-credit-limit-feedback"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!$v.formData.creditLimit.isValidDecimal"
                >Vui lòng nhập số tiền hợp lệ!</b-form-invalid-feedback
              >
              <small class="form-text text-muted">
                <i class="fa fa-exclamation-circle text-warning mr-1 fa-sm"></i>
                Để trống nếu không giới hạn
              </small>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="input-credit-limit">Thông tin khách hàng:</label>
              <b-checkbox v-model="formData.isCustomer"
                >Liên kết thông qua SĐT
              </b-checkbox>
              <small
                id="input-code-help"
                class="form-text text-muted"
                v-if="!formData.code"
              >
                <i class="fa fa-exclamation-circle text-warning mr-1 fa-sm"></i>
                Chọn liên kết nếu bạn muốn liên kết thông tin công nợ khách hàng
                và nhà cung cấp.
              </small>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Row 2: Contact & Business Info -->
        <b-row>
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-mobile">Số điện thoại:</label>
              <b-form-input
                tabindex="5"
                v-model.trim="$v.formData.phoneNo.$model"
                :state="validateState('phoneNo')"
                placeholder="Nhập số điện thoại"
                aria-describedby="input-mobile-live-feedback"
                size="sm"
              />
              <b-form-invalid-feedback v-if="!$v.formData.phoneNo.required"
                >Vui lòng nhập số điện thoại!</b-form-invalid-feedback
              >
              <b-form-invalid-feedback
                v-if="!$v.formData.phoneNo.isValidPhoneNumber"
                >Số điện thoại không hợp lệ!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-tax-no">Mã số thuế:</label>
              <b-form-input
                tabindex="6"
                v-model.trim="$v.formData.taxNo.$model"
                :state="validateState('taxNo')"
                placeholder="Nhập Mã số thuế"
                aria-describedby="input-tax-no-feedback"
                size="sm"
              />
              <b-form-invalid-feedback v-if="!$v.formData.taxNo.required"
                >Yêu cầu mã số thuế!</b-form-invalid-feedback
              >
              <b-form-invalid-feedback v-if="!$v.formData.taxNo.isValidTaxNo"
                >Mã số thuế không hợp lệ!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="input-payment-terms">Cho phép nợ (ngày):</label>
              <b-form-input
                tabindex="8"
                v-model="$v.formData.paymentTermsDays.$model"
                :state="validateState('paymentTermsDays')"
                type="number"
                min="0"
                placeholder="Nhập số ngày cho phép nợ"
                aria-describedby="input-payment-terms-feedback"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!$v.formData.paymentTermsDays.isValidInteger"
                >Vui lòng nhập số ngày hợp lệ!</b-form-invalid-feedback
              >
              <small class="form-text text-muted">
                <i class="fa fa-exclamation-circle text-warning mr-1 fa-sm"></i>
                Để trống nếu không giới hạn
              </small>
            </b-form-group>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>

        <!-- Row 3: Email, Address -->
        <b-row>
          <b-col md="3">
            <b-form-group>
              <label for="input-email">Email:</label>
              <b-form-input
                tabindex="3"
                v-model.trim="$v.formData.email.$model"
                :state="validateState('email')"
                type="email"
                placeholder="Nhập email"
                aria-describedby="input-email-live-feedback"
                size="sm"
              />
              <b-form-invalid-feedback v-if="!$v.formData.email.email"
                >Vui lòng nhập email hợp lệ!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-address"
                >Địa chỉ {{ isIndividualProvider ? '' : 'công ty' }}</label
              >
              <b-form-input
                tabindex="13"
                v-model.trim="$v.formData.address.$model"
                :state="validateState('address')"
                placeholder="Nhập địa chỉ"
                aria-describedby="input-address-live-feedback"
                size="sm"
              />
              <b-form-invalid-feedback v-if="!$v.formData.address.required"
                >Vui lòng nhập địa chỉ!</b-form-invalid-feedback
              >
              <b-form-invalid-feedback v-if="!$v.formData.address.maxLength"
                >Địa chỉ không được vượt quá 400 ký tự!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>

        <!-- Row 4: Identity Card, Shipping Address 1 -->
        <b-row>
          <b-col md="3">
            <b-form-group>
              <label for="input-identity-card">CMND/CCCD:</label>
              <b-form-input
                tabindex="10"
                v-model.trim="formData.identityCard"
                placeholder="Nhập CMND/CCCD"
                size="sm"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group v-if="!isIndividualProvider">
              <label for="input-shipping1">Địa chỉ giao hàng 1:</label>
              <b-form-input
                tabindex="7"
                v-model.trim="$v.formData.shippingAddress1.$model"
                :state="validateState('shippingAddress1')"
                placeholder="Nhập địa chỉ giao hàng chính"
                aria-describedby="input-shipping1-feedback"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!$v.formData.shippingAddress1.maxLength"
                >Địa chỉ không được vượt quá 150 ký tự!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>

        <!-- Row 5: Type, Shipping Address 2 -->
        <b-row>
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-type">Loại nhà cung cấp:</label>
              <b-form-select
                class="select-style"
                tabindex="5"
                v-model="$v.formData.type.$model"
                :options="typeOptions"
                :state="validateState('type')"
                @blur="$v.formData.type.$touch()"
                size="sm"
              />
              <b-form-invalid-feedback v-if="$v.formData.type.$error"
                >Vui lòng chọn loại nhà cung cấp</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group v-if="!isIndividualProvider">
              <label for="input-shipping2">Địa chỉ giao hàng 2:</label>
              <b-form-input
                tabindex="11"
                v-model.trim="$v.formData.shippingAddress2.$model"
                :state="validateState('shippingAddress2')"
                placeholder="Nhập địa chỉ giao hàng phụ (tùy chọn)"
                aria-describedby="input-shipping2-feedback"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!$v.formData.shippingAddress2.maxLength"
                >Địa chỉ không được vượt quá 150 ký tự!</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>

        <!-- Row 6: Supplier Group -->
        <b-row>
          <b-col md="3">
            <b-form-group>
              <label for="input-supplier-group">Nhóm nhà cung cấp:</label>
              <AutoSuggest
                :model="formData.supplierGroupName"
                :suggestions="supplierGroups"
                placeholder="nhóm nhà cung cấp"
                :limit="10"
                @change="onSupplierGroupInputChange"
                @select="onSupplierGroupSelected"
                @focus="onSupplierGroupFocus"
                suggestionName="name"
                :disabled="isLoading"
                :loading="isLoadingSupplierGroups"
                :show-clear="true"
              >
                <template #custom="{ suggestion }">
                  <div>
                    <span>{{ suggestion.item.name }}</span>
                    <span class="text-muted" v-if="suggestion.item.code">
                      ({{ suggestion.item.code }})
                    </span>
                  </div>
                </template>
              </AutoSuggest>
              <small class="form-text text-muted">
                <i class="fa fa-info-circle text-info mr-1 fa-sm"></i> Tùy chọn
                - Chọn nhóm để phân loại nhà cung cấp
              </small>
            </b-form-group>
          </b-col>
          <b-col md="3"></b-col>
          <b-col md="3"></b-col>
        </b-row>
        <b-row>
          <b-col md="3">
          </b-col>
        </b-row>

        <!-- Row 7: Status -->
        <b-row v-if="isEditMode">
          <b-col md="3">
            <b-form-group class="required-control">
              <label for="input-status">Trạng thái:</label>
              <b-form-select
                class="select-style"
                v-model="$v.formData.status.$model"
                :options="statusOptions"
                :state="validateState('status')"
                @blur="$v.formData.status.$touch()"
                size="sm"
              />
              <b-form-invalid-feedback v-if="$v.formData.status.$error"
                >Vui lòng chọn trạng thái</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </b-overlay>
</template>

<script>
import ProviderRepository from '@/repositories/ProviderRepository';
import { isValidTaxNo } from '@/utils/validation';
import AutoSuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { SupplierGroupService } from '@/view/pages/supplier-group/service/supplier-group.service.js';
import debounce from 'debounce';
import { validationMixin } from 'vuelidate';
import {
  email,
  maxLength,
  minLength,
  required,
} from 'vuelidate/lib/validators';

const DEFAULT_FORM_DATA = {
  name: '',
  phoneNo: '',
  email: '',
  taxNo: '',
  identityCard: '',
  address: '',
  code: '',
  shippingAddress1: '',
  shippingAddress2: '',
  creditLimit: null,
  paymentTermsDays: null,
  type: '2',
  status: '1',
  supplierGroupId: null,
  supplierGroupName: '',
  parentId: null,
};

export default {
  name: 'ProviderForm',
  components: {
    AutoSuggest,
  },
  mixins: [validationMixin],
  props: {
    initialData: {
      type: Object,
      default: () => ({ ...DEFAULT_FORM_DATA }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    /** ID NCC đang sửa (để loại khỏi danh sách chọn NCC chính) */
    providerId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      formData: { ...DEFAULT_FORM_DATA },
      textInfo: {
        alignItems: 'center',
        display: 'flex',
        marginTop: '15px',
      },
      typeOptions: [
        { value: '1', text: 'Cá nhân' },
        { value: '2', text: 'Doanh nghiệp' },
      ],
      statusOptions: [
        { value: null, text: '-- Chọn trạng thái --' },
        { value: '1', text: 'Đang giao dịch' },
        { value: '2', text: 'Ngưng giao dịch' },
      ],
      supplierGroups: [],
      isLoadingSupplierGroups: false,
      debouncedSearchSupplierGroups: null,
      allProviders: [],
      loadingProviders: false,
    };
  },
  computed: {
    isIndividualProvider() {
      return ['1', 1].includes(this.formData.type);
    },
    providerOptionsForParent() {
      if (!this.providerId || !this.allProviders.length) return this.allProviders;
      return this.allProviders.filter(
        (p) => Number(p.id) !== Number(this.providerId),
      );
    },
  },
  created() {
    this.searchSupplierGroups();
    this.debouncedSearchSupplierGroups = debounce(
      this.searchSupplierGroups,
      300,
    );
    this.fetchAllProviders();
  },
  watch: {
    initialData: {
      handler(newData) {
        if (newData) {
          this.formData = {
            ...DEFAULT_FORM_DATA,
            ...newData,
            type: String(newData.type || DEFAULT_FORM_DATA.type),
            status: String(newData.status || DEFAULT_FORM_DATA.status),
            creditLimit:
              newData.creditLimit !== undefined ? newData.creditLimit : null,
            paymentTermsDays:
              newData.paymentTermsDays !== undefined
                ? newData.paymentTermsDays
                : null,
            supplierGroupId: newData.supplierGroupId || null,
            supplierGroupName: newData.supplierGroupName || '',
            parentId: newData.parentId ?? newData.parent?.id ?? null,
          };
          this.$nextTick(() => {
            this.$v.$reset();
          });
        }
      },
      immediate: true,
      deep: true,
    },
    'formData.type': function (newType) {
      if (['1', 1].includes(newType)) {
        this.formData.shippingAddress1 = '';
        this.formData.shippingAddress2 = '';
      }
    },
  },
  methods: {
    validateState(name) {
      const field = this.$v.formData[name];
      if (!field) return null;
      const { $dirty, $error } = field;
      return $dirty ? !$error : null;
    },
    submit() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return null;
      }
      const dataToSubmit = { ...this.formData };
      if (this.isIndividualProvider) {
        dataToSubmit.shippingAddress1 = '';
        dataToSubmit.shippingAddress2 = '';
      }
      // Ensure numeric fields are numbers or null
      dataToSubmit.creditLimit =
        dataToSubmit.creditLimit === ''
          ? null
          : parseFloat(dataToSubmit.creditLimit);
      dataToSubmit.paymentTermsDays =
        dataToSubmit.paymentTermsDays === ''
          ? null
          : parseInt(dataToSubmit.paymentTermsDays);

      return dataToSubmit;
    },
    resetForm() {
      this.formData = { ...DEFAULT_FORM_DATA };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async searchSupplierGroups(searchTerm) {
      this.isLoadingSupplierGroups = true;
      try {
        const params = {
          status: 1,
        };

        if (searchTerm && searchTerm.length > 0) {
          params.name = searchTerm;
        }

        const response = await SupplierGroupService.getAllNoPagination(params);

        this.supplierGroups = response.data.data.map((group) => ({
          id: group.id,
          name: group.name,
          code: group.code,
        }));
      } catch (error) {
        console.error('Error searching supplier groups:', error);
        this.supplierGroups = [];
      } finally {
        this.isLoadingSupplierGroups = false;
      }
    },
    onSupplierGroupInputChange(searchTerm) {
      this.debouncedSearchSupplierGroups(searchTerm);
    },
    onSupplierGroupFocus() {
      if (this.supplierGroups.length === 0) {
        this.searchSupplierGroups();
      }
    },
    onSupplierGroupSelected(option) {
      if (option && option.item) {
        this.formData.supplierGroupId = option.item.id;
        this.formData.supplierGroupName = option.item.name;
      } else {
        this.formData.supplierGroupId = null;
        this.formData.supplierGroupName = '';
      }
    },
    async fetchAllProviders() {
      this.loadingProviders = true;
      try {
        const list = await ProviderRepository.getAll();
        this.allProviders = Array.isArray(list) ? list : list?.data ?? [];
      } catch (e) {
        console.error('Error fetching providers for parent:', e);
        this.allProviders = [];
      } finally {
        this.loadingProviders = false;
      }
    },
  },
  validations() {
    const formValidations = {
      formData: {
        name: { required, minLength: minLength(3) },
        email: { email },
        taxNo: { required, isValidTaxNo },
        address: { required, maxLength: maxLength(400) },
        phoneNo: {
          required,
          isValidPhoneNumber: (value) => {
            if (!value) return true;
            const VIETNAM_PHONE_REGEX_EXTENDED =
              /^(0|\+84|84)((3|5|7|8|9)\d{8}|(12|16|18|19)\d{7})$|^(1900)\d{4,8}$/;

            return VIETNAM_PHONE_REGEX_EXTENDED.test(value);
          },
        },
        shippingAddress1: {
          maxLength: maxLength(150),
        },
        shippingAddress2: { maxLength: maxLength(150) },
        creditLimit: {
          isValidDecimal: (value) => {
            if (value === null || value === undefined || value === '')
              return true;
            const num = parseFloat(value);
            return !isNaN(num) && num >= 0;
          },
        },
        paymentTermsDays: {
          isValidInteger: (value) => {
            if (value === null || value === undefined || value === '')
              return true;
            const num = parseInt(value);
            return !isNaN(num) && num >= 0;
          },
        },
        type: { required },
        status: {},
      },
    };
    if (this.isEditMode) {
      formValidations.formData.status = { required };
    }
    return formValidations;
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
}
.required-control label {
  font-weight: 600;
}
.select-style {
  margin-left: auto;
}
</style>
